<template>
    <div>
        <h3>GPTS List &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>

        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="关键字" prop="text">
                        <el-input v-model="form.text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="sort" prop="sort">
                        <el-select v-model="form.sort" placeholder="请选择排序">
                            <el-option label="latest" value="created_at"></el-option>
                            <el-option label="likes" value="like"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="creator" label="作者"></el-table-column>
            <el-table-column prop="description" label="描述"></el-table-column>
            <el-table-column prop="url" label="URL"></el-table-column>
            <el-table-column prop="like" label="like数量" width="150">
                <template slot-scope="scope">
                    <p>like数量：{{ scope.row.like }}</p>
                    <p>推广like：{{ scope.row.promotion_like }}</p>
                    <p>合计：{{ scope.row.total_like }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="添加时间(UTC)" width="150">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
            <el-table-column label="Detail" width="100" fixed="right" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="text" size="small">修改推广like</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <update-modal :dialogVisible="visible" :data="info" @closeModal="close" @update="gptsList()" v-if="visible" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import UpdateModal from './modal/index.vue';
export default {
    components: {
        UpdateModal,
    },
    data() {
        return {
            sum: 0,
            form: {
                text: '',
                sort: '',
            },
            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            // dialog
            visible: false,
            info: {},
        };
    },
    created() {
        this.gptsList();
    },
    methods: {
        async gptsList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                if (params.sort && typeof params.sort === 'string') Object.assign(params, { sort: { [params.sort]: -1 } });
                this.loading = true;
                const { data } = await serverApi.gptsList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },

        search() {
            this.params = { page: 1, size: 10 };
            this.gptsList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.gptsList(this.form);
        },

        handleCurrentChange(val) {
            this.gptsList({ page: val });
        },
        handleUpdate(data) {
            this.info = data;
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
